'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const _commonjsHelpers = require('../../_virtual/_commonjsHelpers.js');
require('./node_modules/is-arrayish/index.js');
const index$1 = require('../../_virtual/index.js_commonjs-proxy');

var simpleSwizzle = _commonjsHelpers.createCommonjsModule(function (module) {


var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle = module.exports = function swizzle(args) {
  var results = [];
  for (var i = 0, len = args.length; i < len; i++) {
    var arg = args[i];
    if (index$1(arg)) {
      // http://jsperf.com/javascript-array-concat-vs-push/98
      results = concat.call(results, slice.call(arg));
    } else {
      results.push(arg);
    }
  }
  return results;
};
swizzle.wrap = function (fn) {
  return function () {
    return fn(swizzle(arguments));
  };
};
});

exports.__moduleExports = simpleSwizzle;
